import reframe from 'nike-re-framejs';
import Immutable from 'immutable';
import { defaultMiddlewares } from '@/common/util';
import ticketusClient from '@/_http/axiosTicketusClient';
import { catcher } from '@/_http/utils';
import { fireGAEvent } from '@/analytics';
import { TAB_LOST_WON_PAID_OUT, TAB_REGISTERED, TABS } from './constants';
import ObjectValues from '@/common/ObjectValues';

const LIMIT = 7;

const fetchHomepageTickets = function({ filter, merge }) {
    ticketusClient
        .get('tickets/mobile', {
            params: {
                start: null,
                end: null,
                limit: LIMIT,
                status: filter.get('type') === 'R' ? ['Registered'] : ['Lost', 'Won', 'PaidOut'],
                offset: filter.get('offset') || 0
            }
        })
        .then(json => reframe.dispatch(['ticketus/homepage/fetched', Immutable.fromJS(json), filter, merge]))
        .catch(catcher.handleMasterError);
};

reframe.regFx('ticketus/homepage/fetch', fetchHomepageTickets);

reframe.regEventFx('ticketus/homepage/initialize', defaultMiddlewares, ({ db }, [_]) => {
    let newDb = db
        .updateIn(['ticketus', 'homepage', 'filter', 'type'], (type = 'R') => type)
        .setIn(['ticketus', 'homepage', 'filter', 'offset'], 0)
        .setIn(['ticketus', 'homepage', 'pending'], true)
        .setIn(['ticketus', 'homepage', 'list', 'hasNextPage'], false);
    return {
        db: newDb,
        'ticketus/homepage/fetch': {
            filter: newDb.getIn(['ticketus', 'homepage', 'filter']),
            merge: false
        }
    };
});

reframe.regEventFx('ticketus/homepage/fetched', defaultMiddlewares, ({ db }, [list, filter, merge]) => {
    if (!Immutable.is(filter, db.getIn(['ticketus', 'homepage', 'filter']))) {
        // ignorujeme data, ako boli loadnute s inym filtrom
        console.log('Ignoring loaded data in [ticketus/homepage/fetched] => filter do not match');
        return { db };
    }

    // ak je to prvotny load a nenasli sa ziadne nevyhodnotene, skusime loadnut vyhodnotene
    if (
        db.getIn(['ticketus', 'homepage', 'filter', 'type']) === 'R' &&
        db.getIn(['ticketus', 'homepage', 'filter', 'offset']) === 0 &&
        !db.getIn(['ticketus', 'homepage', 'initialized']) &&
        list.get('data').size === 0
    ) {
        const newDb = db
            .setIn(['ticketus', 'homepage', 'filter', 'type'], 'D')
            .updateIn(['ticketus', 'homepage', 'ticketsTab'], tab => {
                if (!tab || tab === TAB_REGISTERED) {
                    return TAB_LOST_WON_PAID_OUT;
                }
            });
        return {
            db: newDb,
            'ticketus/homepage/fetch': {
                filter: newDb.getIn(['ticketus', 'homepage', 'filter']),
                merge: false
            }
        };
    }
    return {
        db: db
            .removeIn(['ticketus', 'homepage', 'pending'])
            .setIn(['ticketus', 'homepage', 'initialized'], true)
            .setIn(['ticketus', 'homepage', 'list', 'hasNextPage'], list.get('hasNextPage'))
            .updateIn(['ticketus', 'homepage', 'list', 'data'], old =>
                merge ? old.concat(list.get('data')) : list.get('data')
            )
    };
});

reframe.regEventFx('ticketus/homepage/switchType', defaultMiddlewares, ({ db }, [type]) => {
    let newDb = db;
    newDb = newDb
        .setIn(['ticketus', 'homepage', 'filter', 'type'], type)
        .setIn(['ticketus', 'homepage', 'filter', 'offset'], 0);
    return {
        db: newDb,
        'ticketus/homepage/fetch': {
            filter: newDb.getIn(['ticketus', 'homepage', 'filter']),
            merge: false
        }
    };
});

reframe.regEventFx('ticketus/homepage/load-more', defaultMiddlewares, ({ db }, [_]) => {
    if (db.getIn(['ticketus', 'homepage', 'pending'])) {
        console.warn('can not load-more while pending');
        return { db };
    }
    if (!db.getIn(['ticketus', 'homepage', 'list', 'hasNextPage'])) {
        console.warn('can not load-more without hasNextPage');
        return { db };
    }
    let newDb = db;
    newDb = newDb.updateIn(['ticketus', 'homepage', 'filter', 'offset'], offset => offset + LIMIT);
    return {
        db: newDb,
        'ticketus/homepage/fetch': {
            filter: newDb.getIn(['ticketus', 'homepage', 'filter']),
            merge: true
        }
    };
});

reframe.regEventFx('ticketus/homepage/switchTicketsTab', defaultMiddlewares, ({ db }, [tab]) => {
    if (!ObjectValues(TABS).includes(tab)) return { db };
    if (tab === TAB_REGISTERED) {
        reframe.dispatch(['ticketus/homepage/switchType', 'R']);
    }
    if (tab === TAB_LOST_WON_PAID_OUT) {
        reframe.dispatch(['ticketus/homepage/switchType', 'D']);
    }
    return {
        db: db.setIn(['ticketus', 'homepage', 'ticketsTab'], tab),
        'ticketus/homepage/trackSwitchingTicketsTab': tab
    };
});

reframe.regFx('ticketus/homepage/trackSwitchingTicketsTab', tab => {
    if (tab === TAB_REGISTERED) {
        fireGAEvent('Homepage', 'Nevyhodnotene tikety', 'Tikety');
    }
    if (tab === TAB_LOST_WON_PAID_OUT) {
        fireGAEvent('Homepage', 'Vyhodnotene tikety', 'Tikety');
    }
});
